import { observer } from 'mobx-react-lite';
import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { MenuItemsNavigationCasino } from 'src/components/CasinoPageNavigation/CasinoMenuItems.style';
import { ArrowIconWrapper, MenuButtonWrapper } from 'src/components/Menu/Menu.style';
import { CollectionType } from 'src/domains/casino/models/models';

interface MenuItemsType {
    id: CollectionType;
    label: string;
    onClick: () => void;
}

export const CasinoMenuItems = observer((): JSX.Element | null => {
    const { appCasinoState } = useAppStateContext();
    const { redirectToCollection, casinoTabParam } = appCasinoState.redirectState;

    const isTabActive = (label: string): boolean => {
        return casinoTabParam === label;
    };

    const menuItems: Array<MenuItemsType> = [];

    const { isCollectionAvailable } = appCasinoState;

    if (isCollectionAvailable('casino')) {
        menuItems.push({
            id: 'casino',
            label: 'Casino',
            onClick: (): void => redirectToCollection('casino'),
        });
    }
    if (isCollectionAvailable('live-casino')) {
        menuItems.push({
            id: 'live-casino',
            label: 'Live Casino',
            onClick: (): void => redirectToCollection('live-casino'),
        });
    }
    if (isCollectionAvailable('virtuals')) {
        menuItems.push({
            id: 'virtuals',
            label: 'Virtual Sports',
            onClick: (): void => redirectToCollection('virtuals'),
        });
    }

    return (
        <MenuItemsNavigationCasino>
            {menuItems.map((linkItem) => (
                <MenuButtonWrapper
                    key={linkItem.id}
                    isActive={isTabActive(linkItem.id)}
                    onClick={linkItem.onClick}
                >
                    {linkItem.label}
                    <ArrowIconWrapper
                        isActive={isTabActive(linkItem.id)}
                        position='right'
                    />
                </MenuButtonWrapper>
            ))}
        </MenuItemsNavigationCasino>
    );
});
